/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderPaymentInformation
 */
export interface OrderPaymentInformation {
    /**
     * 
     * @type {string}
     * @memberof OrderPaymentInformation
     */
    paymentType?: string;
}

/**
 * Check if a given object implements the OrderPaymentInformation interface.
 */
export function instanceOfOrderPaymentInformation(value: object): boolean {
    return true;
}

export function OrderPaymentInformationFromJSON(json: any): OrderPaymentInformation {
    return OrderPaymentInformationFromJSONTyped(json, false);
}

export function OrderPaymentInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderPaymentInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
    };
}

export function OrderPaymentInformationToJSON(value?: OrderPaymentInformation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'paymentType': value['paymentType'],
    };
}

